module.exports = __webpack_public_path__ + "img/mm_logo_nobg.9dc2d630.png";